<template>
  <div class="data-manage">
    <div class="main-content" :class="showSearchDrawer ? 'active' : ''">
      <div class="page-title clearfix">
        <div class="float-left">
          <span>{{ $t("nav.data_manage") }}</span>
          <span class="total-num">{{ totalCount }}</span>
        </div>
        <div class="float-right">
          <button
            type="button"
            @click="goAddSubject"
            class="btn btn-danger btn-sm"
          >
            {{ $t("_data.add_data") }}
          </button>
          <!-- <button
            type="button"
            class="btn btn-primary btn-sm ml10"
            @click.stop="handleShowManagerPopover"
          >{{$t('_data.batch_edit')}}</button> -->
        </div>
      </div>
      <div class="data-content">
        <div class="search-wrapper">
          <span class="advanced-btn ml10 mr10" @click="showSearchWrapper">{{
            $t("a_search")
          }}</span>
          <button
            type="button"
            class="search-btn"
            @click.stop="handleCurrentSearch"
          >
            {{ $t("search") }}
          </button>
          <el-form :inline="true" class="search-form" size="small">
            <el-form-item label=" ">
              <el-input
                v-model="search"
                clearable
                :placeholder="$t('analyse.fuzzy_search')"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="search-selections clearfix">
            <span class="fl item mr5" v-if="searchFormData.search_number">
              <span class="item-name">{{ $t("_data.p_name") }}：</span>
              <span class="item-val">{{ searchFormData.search_number }}</span>
              <i
                class="el-icon-close"
                @click="clearSearchParam('search_number')"
              ></i>
            </span>
            <span class="fl item mr5" v-if="searchFormData.search_gender">
              <span class="item-name">{{ $t("gender") }}：</span>
              <span class="item-val">{{
                $t(getGenderKey(searchFormData.search_gender))
              }}</span>
              <i
                class="el-icon-close"
                @click="clearSearchParam('search_gender')"
              ></i>
            </span>
            <span
              class="fl item mr5"
              v-if="
                searchFormData.search_age_min && !searchFormData.search_age_max
              "
            >
              <span class="item-name">{{ $t("age") }}：</span>
              <span class="item-val"
                >{{ searchFormData.search_age_min }}-
              </span>
              <i
                class="el-icon-close"
                @click="clearSearchParam('search_age_min')"
              ></i>
            </span>
            <span
              class="fl item mr5"
              v-if="
                !searchFormData.search_age_min && searchFormData.search_age_max
              "
            >
              <span class="item-name">{{ $t("age") }}：</span>
              <span class="item-val">
                -{{ searchFormData.search_age_max }}</span
              >
              <i
                class="el-icon-close"
                @click="clearSearchParam('search_age_max')"
              ></i>
            </span>
            <span
              class="fl item mr5"
              v-if="
                searchFormData.search_age_min && searchFormData.search_age_max
              "
            >
              <span class="item-name">{{ $t("age") }}：</span>
              <span class="item-val"
                >{{ searchFormData.search_age_min }}-{{
                  searchFormData.search_age_max
                }}</span
              >
              <i
                class="el-icon-close"
                @click="clearSearchParam('clearAges')"
              ></i>
            </span>
            <span class="fl item mr5" v-if="create_date.length > 0">
              <span class="item-name">{{ $t("project.up_time") }}：</span>
              <span class="item-val"
                >{{ create_date[0] }}-{{ create_date[1] }}</span
              >
              <i
                class="el-icon-close"
                @click="clearSearchParam('create_date')"
              ></i>
            </span>
            <span class="fl item mr5" v-if="study_date.length > 0">
              <span class="item-name">{{ $t("project.s_date") }}：</span>
              <span class="item-val"
                >{{ study_date[0] }}-{{ study_date[1] }}</span
              >
              <i
                class="el-icon-close"
                @click="clearSearchParam('study_date')"
              ></i>
            </span>
            <span
              class="fl item mr5"
              v-if="searchFormData.search_modality.length > 0"
            >
              <span class="item-name">{{ $t("project.modality") }}：</span>
              <span
                class="item-val"
                v-for="item in searchFormData.search_modality"
                :key="item"
                >{{ item }}</span
              >
              <i
                class="el-icon-close"
                @click="clearSearchParam('search_modality')"
              ></i>
            </span>
            <span
              class="fl item mr5"
              v-if="searchFormData.search_series.length > 0"
            >
              <span class="item-name">{{ $t("_data.series_type") }}：</span>
              <span
                class="item-val"
                v-for="item in searchFormData.search_series"
                :key="item"
                >{{ item }}</span
              >
              <i
                class="el-icon-close"
                @click="clearSearchParam('search_series')"
              ></i>
            </span>
            <span
              class="fl item mr5"
              v-if="searchFormData.search_tag.length > 0"
            >
              <span class="item-name">{{ $t("_data.tags") }}：</span>
              <span
                class="item-val"
                v-for="item in searchFormData.search_tag"
                :key="item"
                >{{ item }}</span
              >
              <i
                class="el-icon-close"
                @click="clearSearchParam('search_tag')"
              ></i>
            </span>

            <!-- 
            <span
              class="fl item mr5"
              v-if="searchFormData.diagnosis_tags.diagnosis != ''"
            >
              <span class="item-name"
                >{{ $t("tags.subject_diagnosis") }}：</span
              >
              <span class="item-val">{{
                searchFormData.diagnosis_tags.diagnosis
              }}</span>
              <i
                class="el-icon-close"
                @click="clearSearchParam('diagnosis')"
              ></i>
            </span>
            <span
              class="fl item mr5"
              v-if="searchFormData.diagnosis_tags.sideonset != ''"
            >
              <span class="item-name"
                >{{ $t("tags.subject_sideonset") }}：</span
              >
              <span class="item-val">{{
                searchFormData.diagnosis_tags.sideonset
              }}</span>
              <i
                class="el-icon-close"
                @click="clearSearchParam('sideonset')"
              ></i>
            </span> 

            <span
              class="fl item mr5"
              v-if="
                searchFormData.diagnosis_tags.hystaging_min ||
                searchFormData.diagnosis_tags.hystaging_max
              "
            >
              <span class="item-name">{{ $t("tags.subject_staging") }}：</span>
              <span class="item-val"
                >{{ searchFormData.diagnosis_tags.hystaging_min }} -
                {{ searchFormData.diagnosis_tags.hystaging_max }}</span
              >
              <i
                class="el-icon-close"
                @click="clearSearchParam('subject_staging')"
              ></i>
            </span>

            <span
              class="fl item mr5"
              v-if="
                searchFormData.diagnosis_tags.course_min ||
                searchFormData.diagnosis_tags.course_max
              "
            >
              <span class="item-name">{{ $t("tags.subject_disease") }}：</span>
              <span class="item-val"
                >{{ searchFormData.diagnosis_tags.course_min }} -
                {{ searchFormData.diagnosis_tags.course_max }}</span
              >
              <i
                class="el-icon-close"
                @click="clearSearchParam('subject_disease')"
              ></i>
            </span>

            <span
              class="fl item mr5"
              v-if="
                searchFormData.diagnosis_tags.mmse_min ||
                searchFormData.diagnosis_tags.mmse_max
              "
            >
              <span class="item-name">MMSE：</span>
              <span class="item-val"
                >{{ searchFormData.diagnosis_tags.mmse_min }} -
                {{ searchFormData.diagnosis_tags.mmse_max }}</span
              >
              <i class="el-icon-close" @click="clearSearchParam('mmse')"></i>
            </span>

            <span
              class="fl item mr5"
              v-if="
                searchFormData.diagnosis_tags.moca_min ||
                searchFormData.diagnosis_tags.moca_max
              "
            >
              <span class="item-name">MOCA：</span>
              <span class="item-val"
                >{{ searchFormData.diagnosis_tags.moca_min }} -
                {{ searchFormData.diagnosis_tags.moca_max }}</span
              >
              <i class="el-icon-close" @click="clearSearchParam('moca')"></i>
            </span>

            <span
              class="fl item mr5"
              v-if="
                searchFormData.diagnosis_tags.hama_min ||
                searchFormData.diagnosis_tags.hama_max
              "
            >
              <span class="item-name">HAMA：</span>
              <span class="item-val"
                >{{ searchFormData.diagnosis_tags.hama_min }} -
                {{ searchFormData.diagnosis_tags.hama_max }}</span
              >
              <i class="el-icon-close" @click="clearSearchParam('hama')"></i>
            </span>

            <span
              class="fl item mr5"
              v-if="
                searchFormData.diagnosis_tags.hamd_min ||
                searchFormData.diagnosis_tags.hamd_max
              "
            >
              <span class="item-name">HAMD：</span>
              <span class="item-val"
                >{{ searchFormData.diagnosis_tags.hamd_min }} -
                {{ searchFormData.diagnosis_tags.hamd_max }}</span
              >
              <i class="el-icon-close" @click="clearSearchParam('hamd')"></i>
            </span>

            <span
              class="fl item mr5"
              v-if="
                searchFormData.diagnosis_tags.updrs1_min ||
                searchFormData.diagnosis_tags.updrs1_max
              "
            >
              <span class="item-name">UPDRS-I：</span>
              <span class="item-val"
                >{{ searchFormData.diagnosis_tags.updrs1_min }} -
                {{ searchFormData.diagnosis_tags.updrs1_max }}</span
              >
              <i class="el-icon-close" @click="clearSearchParam('updrs1')"></i>
            </span>

            <span
              class="fl item mr5"
              v-if="
                searchFormData.diagnosis_tags.updrs2_min ||
                searchFormData.diagnosis_tags.updrs2_max
              "
            >
              <span class="item-name">UPDRS-II：</span>
              <span class="item-val"
                >{{ searchFormData.diagnosis_tags.updrs2_min }} -
                {{ searchFormData.diagnosis_tags.updrs2_max }}</span
              >
              <i class="el-icon-close" @click="clearSearchParam('updrs2')"></i>
            </span>

            <span
              class="fl item mr5"
              v-if="
                searchFormData.diagnosis_tags.updrs3_min ||
                searchFormData.diagnosis_tags.updrs3_max
              "
            >
              <span class="item-name">UPDRS-III：</span>
              <span class="item-val"
                >{{ searchFormData.diagnosis_tags.updrs3_min }} -
                {{ searchFormData.diagnosis_tags.updrs3_max }}</span
              >
              <i class="el-icon-close" @click="clearSearchParam('updrs3')"></i>
            </span>

            <span
              class="fl item mr5"
              v-if="
                searchFormData.diagnosis_tags.updrs4_min ||
                searchFormData.diagnosis_tags.updrs4_max
              "
            >
              <span class="item-name">UPDRS-VI：</span>
              <span class="item-val"
                >{{ searchFormData.diagnosis_tags.updrs4_min }} -
                {{ searchFormData.diagnosis_tags.updrs4_max }}</span
              >
              <i class="el-icon-close" @click="clearSearchParam('updrs4')"></i>
            </span>
-->
            <span
              class="fl mr5 clear-search"
              v-if="showClearAllSearch"
              @click="resetForm('searchForm')"
              >{{ $t("_data.clear_filter") }}</span
            >
          </div>
        </div>
        <div class="data-process" v-if="processList.length > 0">
          <el-carousel
            height="20px"
            direction="vertical"
            arrow="never"
            indicator-position="none"
          >
            <el-carousel-item v-for="item in processList" :key="item.id">
              <div
                class="data-item clearfix"
                :class="processClass(item.status)"
              >
                <span class="fl mr5">{{ item.file_name }}</span>
                <span class="fl mr10">{{ item.status | formatStatus }}</span>
                <span v-if="item.status === '2'" class="fl mr10"
                  >{{ $t("package_status.failure_reason") }}：{{
                    item.error_status | formatMessage
                  }}</span
                >
                <span class="fl">{{ item.date_created }}</span>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="tabel-content">
          <el-table
            ref="multipleTable"
            :data="dataList"
            :empty-text="$t('no_data')"
            stripe
            header-row-class-name="thead-dark"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
            style="width: 100%"
          >
            <el-table-column
              type="selection"
              :label="$t('_data.all')"
              width="45"
              fixed
            ></el-table-column>
            <el-table-column
              prop="subject_name"
              :label="$t('_data.p_name')"
              width="180"
              fixed
            >
              <template v-slot="scope">
                <router-link
                  :to="{
                    name: 'subjectDetail',
                    query: {
                      id: scope.row.id,
                      offset: currentPage,
                      from: 'datalist',
                    },
                  }"
                  >{{ scope.row.subject_name }}</router-link
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="subject_gender"
              :formatter="formatGender"
              :label="$t('gender')"
              width="70"
            ></el-table-column>
            <el-table-column
              prop="subject_age"
              :label="$t('age')"
              width="80"
              sortable="custom"
            >
              <template v-slot="scope">
                <span>
                  {{ scope.row.subject_age }}
                </span>
                <span v-if="scope.row.subject_age">
                  {{ $t($helper.formatAgeUnit(scope.row.subject_age_unit)) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="study_date"
              :label="$t('project.s_date')"
              sortable="custom"
              width="120"
            >
            </el-table-column>

            <el-table-column
              prop="date_update"
              :label="$t('project.up_time')"
              sortable="custom"
              width="120"
            ></el-table-column>
            <!-- 
            <el-table-column
              prop="patient_id"
              label="Patient ID"
            ></el-table-column> -->
            <el-table-column
              prop="modality"
              :formatter="formatModality"
              :label="$t('project.modality')"
            ></el-table-column>
            <!--诊断标签-->
            <!-- <el-table-column
              prop="diagnosis_tags.diagnosis"
              :label="$t('tags.subject_diagnosis')"
            ></el-table-column>

            <el-table-column
              prop="diagnosis_tags.course"
              :label="$t('tags.subject_disease')"
            >
              <template v-slot="scope">
                <span>
                  {{ scope.row.diagnosis_tags.course }}
                </span>
                <span v-if="scope.row.diagnosis_tags.course">
                  ({{ $t("_data.month") }})
                </span>
              </template>
            </el-table-column>

            <el-table-column
              prop="diagnosis_tags.hy_staging"
              :label="$t('tags.subject_staging')"
            ></el-table-column>

            <el-table-column
              prop="diagnosis_tags.sideonset"
              :label="$t('tags.subject_sideonset')"
            ></el-table-column>

            <el-table-column
              prop="diagnosis_tags.updrs3"
              label="UPDRS-III"
            ></el-table-column> -->

            <el-table-column :label="$t('_data.tags')">
              <template v-slot="scope">
                <span class="mr5" v-for="tag in scope.row.tags" :key="tag.id">{{
                  tag.name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="user.realname"
              :label="$t('_data.data_owner') + '(' + $t('sign.username') + ')'"
            >
              <template v-slot="scope">
                <span>
                  {{ scope.row.user.realname }} ({{ scope.row.user.username }})
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="user.department_name"
              :label="$t('_data.department')"
            ></el-table-column>

            <el-table-column :label="$t('operate')" align="right" fixed="right">
              <template v-slot="scope">
                <el-dropdown>
                  <span class="el-dropdown-link cursor">
                    <i class="fa fa-bars mr-1"></i>
                    <i class="fa fa-angle-down"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item disabled>{{
                      $t("operate_menu")
                    }}</el-dropdown-item>

                    <el-dropdown-item
                      divided
                      v-if="dataOwnerScope(scope.row)"
                      class="dropdown-item cursor"
                      @click.native="modifyInfo(scope.row)"
                    >
                      <i class="fa fa-edit"></i> {{ $t("_data.edit_p_info") }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      class="dropdown-item cursor"
                      @click.native="modalDownload(scope.row, 'nifti')"
                    >
                      <i class="fa fa-download"></i> {{ $t("_data.d_nif") }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      class="dropdown-item cursor"
                      @click.native="modalDownload(scope.row, 'dicom')"
                    >
                      <i class="fa fa-download"></i> {{ $t("_data.d_dic") }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="dataOwnerScope(scope.row)"
                    ></el-dropdown-item>

                    <el-dropdown-item
                      v-if="dataOwnerScope(scope.row)"
                      class="dropdown-item cursor"
                      @click.native="openTagModel(scope.row)"
                    >
                      <i class="fa fa-tags"></i> {{ $t("_data.add_tag") }}
                    </el-dropdown-item>
                    <!-- 
                    <el-dropdown-item
                      v-if="dataOwnerScope(scope.row)"
                      class="dropdown-item cursor"
                      @click.native="openTagModelDiagnosis(scope.row)"
                    >
                      <i class="fa fa-note-sticky"></i>
                      {{ $t("tags.subject_diagnosis") }}{{ $t("_data.tags") }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="dataOwnerScope(scope.row)"
                      class="dropdown-item cursor"
                      @click.native="openTagModelSideonset(scope.row)"
                    >
                      <i class="fa fa-down-left-and-up-right-to-center"></i>
                      {{ $t("tags.subject_sideonset") }}{{ $t("_data.tags") }}
                    </el-dropdown-item>

                    <el-dropdown-item
                      divided
                      v-if="dataOwnerScope(scope.row)"
                      class="dropdown-item cursor"
                      @click.native="openTagModelDisease(scope.row)"
                    >
                      <i class="fa fa-user-tag"></i>
                      {{ $t("tags.diagnosis_tags") }}
                    </el-dropdown-item> -->
                    <el-dropdown-item
                      divided
                      v-if="dataOwnerScope(scope.row)"
                      class="dropdown-item cursor text-danger"
                      @click.native="deleteSubject(scope.row)"
                    >
                      {{ $t("delete") }}
                    </el-dropdown-item>
                    <!-- <el-dropdown-item
                      divided
                      v-if="user.role < 2"
                      class="dropdown-item cursor text-danger"
                      @click.native="deleteSubject(scope.row)"
                    >
                      {{ $t("delete") }}
                    </el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- 

                <div class="dropdown d-inline-block dropleft">
                  <div class="cursor" @click.stop="showMenu(scope.row)">
                    <i class="fa fa-bars mr-1"></i>
                    <i class="fa fa-angle-down"></i>
                  </div>
                  <div
                    class="dropdown-menu shadow-lg"
                    :class="{ show: scope.row.id === rowId }"
                  >
                    <div class="dropdown-header">{{ $t("operate_menu") }}</div>
                    <div
                      v-if="user.id === scope.row.user_id"
                      class="dropdown-item cursor"
                      @click.stop="modifyInfo(scope.row)"
                    >
                      <i class="fa fa-edit"></i> {{ $t("_data.edit_p_info") }}
                    </div>
                    <div
                      class="dropdown-item cursor"
                      @click="modalDownload(scope.row, 'nifti')"
                    >
                      <i class="fa fa-download"></i> {{ $t("_data.d_nif") }}
                    </div>
                    <div
                      class="dropdown-item cursor"
                      @click="modalDownload(scope.row, 'dicom')"
                    >
                      <i class="fa fa-download"></i> {{ $t("_data.d_dic") }}
                    </div>
                    <div
                      v-if="user.id === scope.row.user_id"
                      class="dropdown-divider"
                    ></div>
                    <div
                      v-if="user.id === scope.row.user_id"
                      class="dropdown-item cursor"
                      @click="openTagModel(scope.row)"
                    >
                      <i class="fa fa-tags"></i> {{ $t("_data.add_tag") }}
                    </div>
                    <div class="dropdown-divider"></div>
                    <div
                      v-if="user.id === scope.row.user_id"
                      class="dropdown-item cursor text-danger"
                      @click="deleteSubject(scope.row)"
                    >
                      {{ $t("delete") }}
                    </div>
                  </div>
                </div> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="clearfix my-3">
        <div class="float-left">
          <pagination
            v-if="totalCount > 0"
            :pageSize="pageSize"
            :layout="layout"
            :currentPage="currentPage"
            :total="totalCount"
            @goToPage="handleCurrentChange"
          />
        </div>
        <div class="float-right">
          <!-- <button
            type="button"
            class="btn btn-danger btn-sm ml-2"
            @click.stop="batchRemoveData"
          >
            <i class="fa fa-trash-alt mr-1"></i>
            {{ $t("_data.batch_remove") }}
          </button> -->

          <button
            type="button"
            class="btn btn-warning btn-sm ml-2"
            @click.stop="openToProject"
          >
            <i class="fa fa-bars-progress mr-1"></i>
            {{ $t("_data.batch_add_project") }}
          </button>

          <button
            type="button"
            class="btn btn-info btn-sm ml-2"
            @click.stop="openDataOwnerPopover"
            v-if="user.role < 3"
          >
            <i class="fa fa-users mr-1"></i>
            {{ $t("_data.batch_edit") }}
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm ml-2"
            @click.stop="batchDownloadData"
          >
            <i class="fa fa-download mr-1"></i>
            {{ $t("_data.batch_download") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-sm ml-2"
            @click.stop="exportExcel"
          >
            <i class="fa fa-file-excel mr-1"></i>
            {{ $t("_data.export_excel") }}
          </button>
        </div>
      </div>
    </div>
    <div class="empty-wrapper" :class="showSearchDrawer ? 'active' : ''"></div>
    <div class="search-drawer" :class="showSearchDrawer ? 'active' : ''">
      <p class="top-line clearfix">
        <span>{{ $t("a_search") }}</span>
        <span class="float-right close-search" @click="hideSearchWrapper">
          <i class="el-icon-close"></i>
        </span>
      </p>
      <div class="drawer-body">
        <div class="form-wrapper">
          <el-form
            :model="searchFormData"
            ref="searchForm"
            label-position="top"
            size="mini"
            class="search-form"
          >
            <el-form-item :label="$t('_data.p_name')" prop="search_number">
              <el-input
                v-model="searchFormData.search_number"
                @change="handleAdvanceSearch"
                @keydown.enter.stop="handleAdvanceSearch"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('gender')" prop="search_gender">
              <el-select
                v-model="searchFormData.search_gender"
                @change="handleAdvanceSearch"
                placeholder=" "
              >
                <el-option :label="$t('male')" value="M"></el-option>
                <el-option :label="$t('female')" value="F"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('age')" prop="age">
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.search_age_min"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.search_age_max"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('project.s_date')">
              <el-date-picker
                v-model="study_date"
                value-format="yyyy-MM-dd"
                type="daterange"
                size="mini"
                :clearable="clearable"
                prefix-icon=" "
                range-separator="-"
                @change="handleAdvanceSearch"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('project.up_time')">
              <el-date-picker
                v-model="create_date"
                value-format="yyyy-MM-dd"
                type="daterange"
                size="mini"
                :clearable="clearable"
                prefix-icon=" "
                range-separator="-"
                @change="handleAdvanceSearch"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('project.modality')">
              <el-select
                v-model="searchFormData.search_modality"
                multiple
                @change="handleAdvanceSearch"
                placeholder=" "
              >
                <el-option
                  v-for="(item, index) in modalityOptions"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('_data.series_type')">
              <el-select
                v-model="searchFormData.search_series"
                multiple
                @change="handleAdvanceSearch"
                placeholder=" "
              >
                <el-option
                  v-for="(item, index) in seriesOptions"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="block">
              <span class="demonstration">{{ $t("_data.tags") }}</span>
              <el-select
                v-model="searchFormData.search_tag"
                multiple
                size="mini"
                @change="handleAdvanceSearch"
                placeholder=" "
              >
                <el-option
                  v-for="(item, index) in searchTagOptions"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
            <!-- 
            <div class="cutting-line py-1 mt-3"></div>
            <el-form-item :label="$t('tags.subject_diagnosis')">
              <el-select
                v-model="searchFormData.diagnosis_tags.diagnosis"
                multiple
                @change="handleAdvanceSearch"
                placeholder=" "
              >
                <el-option
                  v-for="(item, index) in diagnosisOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('tags.subject_sideonset')">
              <el-select
                v-model="searchFormData.diagnosis_tags.sideonset"
                multiple
                @change="handleAdvanceSearch"
                placeholder=" "
              >
                <el-option
                  v-for="(item, index) in sideonsetOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('tags.subject_staging')">
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.hystaging_min"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.hystaging_max"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('tags.subject_disease')">
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.course_min"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.course_max"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="MMSE">
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.mmse_min"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.mmse_max"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="MOCA">
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.moca_min"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.moca_max"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="HAMA">
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.hama_min"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.hama_max"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="HAMD">
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.hamd_min"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.hamd_max"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="UPDRS-I">
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.updrs1_min"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.updrs1_max"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="UPDRS-II">
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.updrs2_min"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.updrs2_max"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="UPDRS-III">
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.updrs3_min"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.updrs3_max"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="UPDRS-IV">
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.updrs4_min"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="searchFormData.diagnosis_tags.updrs4_max"
                    @change="handleAdvanceSearch"
                    @keydown.enter.stop="handleAdvanceSearch"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('tags.education')">
              <el-input
                v-model="searchFormData.diagnosis_tags.education"
                @change="handleAdvanceSearch"
                @keydown.enter.stop="handleAdvanceSearch"
                autocomplete="off"
              ></el-input>
            </el-form-item> -->
          </el-form>
        </div>
        <div class="button-wrapper">
          <button
            type="button"
            class="btn btn-primary btn-sm mr10"
            @click.stop="handleAdvanceSearch"
          >
            {{ $t("a_search") }}
          </button>
          <el-button size="small" @click="resetForm('searchForm')">{{
            $t("project.clear")
          }}</el-button>
        </div>
      </div>
    </div>
    <div class="brain-popover data-manager-popover" v-if="showOwnerPopover">
      <div class="popover-mask"></div>
      <div class="popover-content">
        <div class="popover-head">{{ $t("_data.batch_edit") }}</div>
        <div class="popover-body">
          <div class="row">
            <label class="col-sm-3 text-right" style="line-height: 32px">
              <span class="text-danger">* </span>{{ $t("_data.data_owner") }}:
            </label>
            <div class="col-sm-9">
              <el-cascader
                v-model="dataOwner"
                size="small"
                :props="{ checkStrictly: true }"
                :options="cascaderOptions"
                filterable
              >
              </el-cascader>
            </div>
          </div>
        </div>
        <div class="popover-footer text-right">
          <button
            type="button"
            class="btn btn-grey btn-sm ml10"
            @click.stop="closeDataOwnerPopover"
          >
            {{ $t("close") }}
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm ml10"
            @click.stop="setDataOwner"
          >
            {{ $t("confirm") }}
          </button>
        </div>
      </div>
    </div>
    <div class="dialog-wrapper" v-if="dialogVisible">
      <div class="dialog-content">
        <div class="dialog-header">
          <span class="dialog-title">{{ $t("_data.tips") }}</span>
          <button
            type="button"
            class="dialog-headerbtn"
            @click="dialogVisible = false"
          >
            <i class="dialog-close el-icon el-icon-close"></i>
          </button>
        </div>
        <div class="dialog-body">
          <span>{{ $t("_data.packing") }}</span>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('notice.pack_ok')"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
      :close-on-click-modal="isClickclose"
      :close-on-press-escape="isClickclose"
      :lock-scroll="isLockScroll"
    >
      <div class="text-center">
        <a
          class="btn btn-primary"
          target="_blank"
          :href="downloadurl"
          style="width: 120px"
          ><i class="el-icon-download"></i> {{ $t("_data.download") }}</a
        >
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>

    <edit-subject
      :patientInfo="edit_subject"
      :showPopover="showEditPopover"
      @closeEditPopover="showEditPopover = false"
      @submitSubject="submitSubject"
    >
    </edit-subject>
    <add-to-project
      :projects="projects"
      :showPopover="showAddPopover"
      @closeAddPopover="showAddPopover = false"
      @handleAddToProject="handleAddToProject"
    />
    <set-tags
      :tagsList="setTagOptions"
      :selectedTags="selectedTags"
      :showPopover="showTagsPopover"
      @closeTagsPopover="showTagsPopover = false"
      @addTag="addTag"
      @submitTags="submitTags"
    ></set-tags>

    <subject_diagnosis
      :tagsList="diagnosisOptions"
      :selectedTags="selectedTagsDiagnosis"
      :showPopover="showPopoverDiagnosis"
      @closeTagsPopover="showPopoverDiagnosis = false"
      @addTagDiagnosis="addTagDiagnosis"
      @submitTagsDiagnosis="submitTagsDiagnosis"
    ></subject_diagnosis>

    <subject_sideonset
      :tagsList="sideonsetOptions"
      :selectedTags="selectedTagsSideonset"
      :showPopover="showPopoverSideonset"
      @closeTagsPopover="showPopoverSideonset = false"
      @addTagSideonset="addTagSideonset"
      @submitTagsSideonset="submitTagsSideonset"
    ></subject_sideonset>

    <subject_disease
      :setTagOptionsHystaging="hystagingOptions"
      :diagnosis_tags="edit_subject.diagnosis_tags"
      :showPopover="showPopoverDisease"
      :subject_id="edit_subject.id"
      @closeTagsPopover="showPopoverDisease = false"
      @submitTagsDisease="submitTagsDisease"
    ></subject_disease>
  </div>
</template>

<script>
import { eventHub } from "@/eventHub.js";
import editSubject from "../../components/subject/editSubject";
import addToProject from "../../components/subject/addToProject";
import setTags from "../../components/subject/setTags";
import subject_diagnosis from "@/components/subject/subject_diagnosis";
import subject_disease from "@/components/subject/subject_disease";
import subject_sideonset from "@/components/subject/subject_sideonset";
import {
  dataRequest,
  dataDownload,
  tagsRequest,
  modalityRequest,
  projectDataRequest,
  cascaderUserRequest,
  dataOwnerRequest,
  downloadPackage,
  subject_tags,
  tag_diagnosis,
  tag_sideonset,
  tag_hystaging,
  tag_diagnosis_create,
  tag_sideonset_create,
  projectRequest,
  projectGroupRequest,
} from "../../api/api";
import pagination from "../../components/pager";
import { paginationMixin } from "../../utils/mixin";
import { MessageBox, Loading } from "element-ui";

let _that;
export default {
  mixins: [paginationMixin],
  components: {
    pagination,
    editSubject,
    addToProject,
    setTags,
    subject_diagnosis,
    subject_disease,
    subject_sideonset,
  },
  data() {
    // console.log("router:::", this.$route.params);
    // console.log("store:::", this.$store.state.dataParams);
    return {
      dataList: [],
      processList: [],
      noTask: false,
      refresh: false,
      interval: null,
      rowId: "",
      user: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {},
      search: this.$store.state.dataParams.search || "",
      searchFormData: {
        search_number: this.$store.state.dataParams.search_number || "",
        search_gender: this.$store.state.dataParams.search_gender || "",
        search_modality: this.$store.state.dataParams.search_modality || [],
        search_series: this.$store.state.dataParams.search_series || [],
        search_tag: this.$store.state.dataParams.search_tag || [],
        search_age_min: this.$store.state.dataParams.search_age_min || "",
        search_age_max: this.$store.state.dataParams.search_age_max || "",
        diagnosis_tags: {
          // diagnosis: [],
          // sideonset: [],
          // hystaging_min: "",
          // hystaging_max: "",
          // course_min: "",
          // course_max: "",
          // mmse_min: "",
          // mmse_max: "",
          // moca_min: "",
          // moca_max: "",
          // hama_min: "",
          // hama_max: "",
          // hamd_min: "",
          // hamd_max: "",
          // updrs1_min: "",
          // updrs1_max: "",
          // updrs2_min: "",
          // updrs2_max: "",
          // updrs3_min: "",
          // updrs3_max: "",
          // updrs4_min: "",
          // updrs4_max: "",
          // education: "",
        },
      },
      modalityOptions: [],
      seriesOptions: [],
      searchTagOptions: [],
      create_date: [],
      study_date: [],
      setTagOptions: [],
      selectedTags: [],
      edit_subject: {},
      clearable: false,
      dialogVisible: false,
      showOwnerPopover: false,
      showSearchDrawer: false,
      showEditPopover: false,
      showAddPopover: false,
      showTagsPopover: false,
      addTagSubjectId: "",
      cascaderOptions: [],
      dataOwner: [],
      pageSize: 25,
      currentPage: parseInt(this.$route.query.offset) || 1,
      totalCount: 0,
      centerDialogVisible: false,
      isClickclose: false,
      isLockScroll: false,
      downloadurl: "",
      //高级搜索 诊断标签
      diagnosisOptions: [],
      //高级搜索 病侧标签
      sideonsetOptions: [],
      //H-Y分期
      hystagingOptions: [],
      //排序
      sort: "", //subject_age, study_date, date_update
      orderby: "", //ascending / descending
      //添加到项目分组
      projects: [],
      //诊断 初存入固定标签+自定义，
      selectedTagsDiagnosis: "",
      showPopoverDiagnosis: false,
      //病程 “病程”：整数月（手动输）
      showPopoverDisease: false,

      //起病侧 标签内容：左侧、左侧-上肢、左侧-下肢、右侧、右侧-上肢、右侧-下肢、不明确、自定义
      selectedTagsSideonset: "",
      showPopoverSideonset: false,

      //Table: subject_hystaging “H-Y分期” 标签内容：标签内容：0、1、1.5、2、2.5、3、4、5
      setTagOptionsHystaging: [],
    };
  },
  methods: {
    showSearchWrapper() {
      this.showSearchDrawer = true;
    },
    hideSearchWrapper() {
      this.showSearchDrawer = false;
    },
    handleAdvanceSearch() {
      //点击高级搜索按钮
      //console.log("handleAdvanceSearch");
      this.currentPage = 1;
      this.search = "";
      this.getDataList();
    },
    handleCurrentSearch() {
      //点击上方的搜索按钮
      //console.log("handleCurrentSearch");
      this.currentPage = 1;
      this.getDataList();
    },
    async getDataList() {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        request: "listallsubjects",
        userid: this.$store.state.userid,
        limit: this.pageSize,
        offset: this.currentPage - 1, //offset 0:第一页，1：第二页，...;
        search: this.search,
        ...this.searchFormData,
        search_createdate_min: this.create_date[0] || "",
        search_createdate_max: this.create_date[1] || "",
        search_studydate_min: this.study_date[0] || "",
        search_studydate_max: this.study_date[1] || "",
        orderby: this.orderby,
        sort: this.sort,
      };

      this.$store.state.dataParams = params;

      try {
        let res = await dataRequest(params);
        if (res.status === 200) {
          this.dataList = res.data.length > 0 ? res.data : [];
          this.totalCount = res.total;
        } else {
          this.dataList = [];
          this.totalCount = 0;
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    //导出数据,后端方法与高级搜索一致
    async exportExcel() {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        request: "export_all_subjects",
        userid: this.$store.state.userid,
        search: this.search,
        ...this.searchFormData,
        search_createdate_min: this.create_date[0] || "",
        search_createdate_max: this.create_date[1] || "",
        search_studydate_min: this.study_date[0] || "",
        search_studydate_max: this.study_date[1] || "",
        orderby: this.orderby,
        sort: this.sort,
      };

      try {
        let res = await dataRequest(params);
        if (res.status === 200) {
          this.iframDownload(res.download_url);
          this.$helper.successNotify(res.message);
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    iframDownload(url) {
      const me = this;
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.style.height = 0;
      iframe.src = url;
      document.body.appendChild(iframe);
      setTimeout(() => {
        iframe.remove();
      }, 13000);
    },
    //获取级联用户列表
    async getCascaderOptions() {
      try {
        let res = await cascaderUserRequest();
        if (res.status === 200) {
          this.cascaderOptions = res.data ? res.data : [];
        }
      } catch (error) {
        this.$helper.errNotify(error.message);
      }
    },
    //获取高级搜索模态和序列
    async getModalityAndSeries() {
      try {
        let res = await modalityRequest();
        if (res.status === 200) {
          this.modalityOptions = res.data.data_modality
            ? res.data.data_modality
            : [];
          this.seriesOptions = res.data.data_series ? res.data.data_series : [];
          this.searchTagOptions = res.data.data_tags ? res.data.data_tags : [];
        }
      } catch (error) {
        this.$helper.errNotify(error.message);
      }
    },
    //获取高级搜索诊断标签
    async getTagOptionsDiagnosis() {
      try {
        let res = await tag_diagnosis();
        if (res.status === 200) {
          this.diagnosisOptions = res.data.length > 0 ? res.data : [];
        }
      } catch (error) {}
    },
    //获取高级搜索病侧标签
    async getTagOptionsSideonset() {
      try {
        let res = await tag_sideonset();
        if (res.status === 200) {
          this.sideonsetOptions = res.data.length > 0 ? res.data : [];
        }
      } catch (error) {}
    },
    //获取高级搜索H-Y分期标签
    async getTagOptionsHystaging() {
      try {
        let res = await tag_hystaging();
        if (res.status === 200) {
          this.hystagingOptions = res.data.length > 0 ? res.data : [];
        }
      } catch (error) {}
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDataList();
    },
    //获取顶部数据处理情况
    async getProcessList() {
      let params = {
        request: "upload_state",
        userid: this.$store.state.userid,
        projectid: "",
      };

      try {
        let res = await projectDataRequest(params);
        if (res.status === 200) {
          let resData = res.data;
          //this.refresh = this.processList.toString() !== resData.toString();
          //this.noTask = resData.length === 0;
          this.processList = resData.length > 0 ? resData : [];
        } else {
          this.processList = [];
          this.clearTimer();
        }
      } catch (error) {
        this.clearTimer();
        this.$helper.errNotify(error.message);
      }
    },
    processClass(status) {
      switch (status) {
        case "0":
          return "item-primary";
        case "1":
          return "item-success";
        case "2":
          return "item-danger";
        default:
          return "";
      }
    },
    resetForm(formName) {
      this.currentPage = 1;
      this.searchFormData.search_number = "";
      this.searchFormData.search_gender = "";
      this.searchFormData.search_modality = [];
      this.searchFormData.search_series = [];
      this.searchFormData.search_tag = [];
      this.searchFormData.search_age_min = "";
      this.searchFormData.search_age_max = "";
      //this.searchFormData.diagnosis_tags = {};
      this.study_date = [];
      this.create_date = [];
      this.$refs.searchForm.resetFields();
      this.searchFormData = this.clearFormData(this.searchFormData);
      this.getDataList();
    },
    openDataOwnerPopover() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$helper.warningMessage(this.$t("notice.select_data"));
        return;
      }
      this.showOwnerPopover = true;
    },
    closeDataOwnerPopover() {
      this.showOwnerPopover = false;
      this.dataOwner = [];
    },
    async setDataOwner() {
      if (this.dataOwner.length === 0) {
        this.$helper.warningMessage(this.$t("notice.select_data_owner"));
        return;
      }

      let subjects = this.multipleSelection.map(function (item) {
        return item.id;
      });

      const _index = this.dataOwner.length - 1;
      let params = {
        subject_ids: subjects,
        user_id: this.dataOwner[_index],
      };

      try {
        let res = await dataOwnerRequest(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getDataList();
          this.showOwnerPopover = false;
          this.dataOwner = [];
        } else {
          this.$helper.errNotify(res.message);
        }
      } catch (error) {
        this.$helper.errNotify(error.message);
      }
    },
    handleSelectionChange(value) {
      this.multipleSelection = value;
    },
    goAddSubject() {
      this.$router.push("/data-manage/add-subject");
    },
    formatGender: function (row) {
      return row.subject_gender === "1"
        ? this.$t("female")
        : row.subject_gender === "0"
        ? this.$t("male")
        : "";
    },
    formatModality: function (row) {
      let modalityStr = "";
      if (row.modality && row.modality.length > 0) {
        modalityStr = row.modality.reduce((x, y) => {
          return x + " " + y;
        });
      }
      return modalityStr;
    },
    showMenu(rowData) {
      this.rowId = rowData.id;
    },
    hideMenu() {
      this.rowId = "";
    },
    async modalDownload(subject, type) {
      const me = this;
      //this.dialogVisible = true;
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.rowId = "";
      const { id } = this.user;
      let params = {
        userid: id,
        subjectid: subject.id,
        projectid: subject.project_id || 0,
        request: "download_" + type,
      };
      try {
        let res = await downloadPackage(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          eventHub.$emit("getProcessList");

          //window.open(res.downloadurl);
          //换弹窗，链接打开下载url;
          // me.downloadurl = res.downloadurl;
          // me.centerDialogVisible = true;
        } else {
          this.$helper.errNotify(res.message);
        }
        //this.dialogVisible = false;

        loadingInstance.close();
      } catch (error) {
        //this.dialogVisible = false;
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    //批量下载
    async batchDownloadData() {
      const me = this;
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$helper.warningMessage(this.$t("notice.select_tip"));
        return;
      }
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });
      const { id } = this.user;
      let subjects = this.multipleSelection.map(function (item) {
        return item.id;
      });
      let params = {
        userid: id,
        subjects: subjects,
        projectid: 0,
        request: "batch_download_subject_list",
      };
      try {
        let res = await downloadPackage(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          //location.href = res.downloadurl;
          eventHub.$emit("getProcessList");

          //换弹窗，链接打开下载url;
          // me.downloadurl = res.downloadurl;
          // me.centerDialogVisible = true;
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    deleteSubject(subject) {
      MessageBox.confirm(this.$t("notice.p_confirm"), this.$t("notice.tips"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      })
        .then(() => {
          this.deleteSubjectFunc(subject);
        })
        .catch(() => {});
    },
    async deleteSubjectFunc(subject) {
      this.rowId = "";
      let params = {
        request: "remove",
        userid: this.user.id,
        subject_id: subject.id,
        projectid: subject.project_id || 0,
        groupid: subject.group_id || 0,
      };
      try {
        let res = await dataRequest(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getDataList();
        } else {
          this.$helper.errNotify(res.message);
        }
      } catch (error) {
        this.$helper.errNotify(error.message);
      }
    },
    batchRemoveData() {
      // const me = this;
      // if (!this.multipleSelection || this.multipleSelection.length === 0) {
      //   this.$helper.warningMessage(this.$t("notice.select_tip"));
      //   return;
      // }
      // this.dialogVisible = true;
      // const { id } = this.user;
      // let subjects = this.multipleSelection.map(function (item) {
      //   return item.id;
      // });
      // MessageBox.confirm(this.$t("notice.p_confirm"), this.$t("notice.tips"), {
      //   confirmButtonText: this.$t("confirm"),
      //   cancelButtonText: this.$t("cancel"),
      //   type: "warning",
      // })
      //   .then(() => {
      //     this.deleteSubjectFunc(subject);
      //   })
      //   .catch(() => {});
    },
    modifyInfo(subject) {
      this.edit_subject = {
        subject_id: subject.id,
        subject_name: subject.subject_name,
        subject_age: subject.subject_age,
        subject_age_unit: subject.subject_age_unit,
        subject_gender: subject.subject_gender,
        subject_explain: subject.subject_explain,
        project_id: subject.project_id,
      };
      this.showEditPopover = true;
      this.rowId = "";
    },
    async submitSubject(subject) {
      let _self = this;
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        request: "edit",
        userid: _self.$store.state.userid,
        ...subject,
      };
      try {
        let res = await dataRequest(params);
        if (res.status === 200) {
          _self.$helper.successNotify(res.message);
          _self.getDataList();
          _self.showEditPopover = false;
        } else {
          _self.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        _self.$helper.errNotify(error.message);
        loadingInstance.close();
      }
    },
    async getTagOptions() {
      let params = {
        request: "list",
        userid: this.$store.state.userid,
      };
      try {
        let res = await tagsRequest(params);
        if (res.status === 200) {
          this.setTagOptions = res.data.length > 0 ? res.data : [];
        }
      } catch (error) {}
    },
    openTagModel(rowData) {
      this.selectedTags = rowData.tags.map(function (item) {
        return item.id;
      });
      this.addTagSubjectId = rowData.id;
      this.showTagsPopover = true;
    },
    async addTag(tagName) {
      if (!tagName) {
        this.$helper.warningMessage(this.$t("notice.tag_name_required"));
        return false;
      }

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        request: "insert",
        userid: this.$store.state.userid,
        name: tagName,
      };
      try {
        let res = await tagsRequest(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getTagOptions();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    async submitTags(tags) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        request: "tagsubject",
        userid: this.$store.state.userid,
        subject_id: this.addTagSubjectId,
        tagids: tags,
        tagname: "",
      };
      try {
        let res = await tagsRequest(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getDataList();
          this.showTagsPopover = false;
          this.addTagSubjectId = "";
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        this.$helper.errNotify(error.message);
        loadingInstance.close();
      }
    },
    isEmpty(value) {
      if (typeof value === "string") {
        return value.trim() === "";
      }
      if (Array.isArray(value)) {
        return value.length === 0;
      }
      if (typeof value === "object" && value !== null) {
        return (
          Object.keys(value).length === 0 ||
          Object.values(value).every(this.isEmpty)
        );
      }
      return false;
    },

    areAllValuesEmpty(json) {
      for (const key in json) {
        if (Object.hasOwn(json, key)) {
          const value = json[key];
          if (!this.isEmpty(value)) {
            return false;
          }
        }
      }
      return true;
    },
    checkFormFieldsEmpty(formData) {
      if (this.isEmpty(formData)) {
        console.log("表单所有字段都为空");
        return true;
      } else {
        console.log("表单字段不全为空");
        return false;
      }
    },
    clearFormData(obj) {
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const value = obj[key];
          if (typeof value === "string") {
            obj[key] = "";
          } else if (Array.isArray(value)) {
            obj[key] = [];
          } else if (typeof value === "object" && value !== null) {
            this.clearFormData(value);
          }
        }
      }
      return obj;
    },
    //删除单个搜索显示
    clearSearchParam(searchParam) {
      if (
        [
          "search_number",
          "search_gender",
          "search_age_min",
          "search_age_max",
        ].indexOf(searchParam) > -1
      ) {
        this.searchFormData[searchParam] = "";
      } else if (
        ["search_modality", "search_series", "search_tag"].indexOf(
          searchParam
        ) > -1
      ) {
        this.searchFormData[searchParam] = [];
      } else if (["create_date", "study_date"].indexOf(searchParam) > -1) {
        this[searchParam] = [];
      } else if (searchParam === "clearAges") {
        this.searchFormData.search_age_min = "";
        this.searchFormData.search_age_max = "";
      } else if (["diagnosis", "sideonset"].indexOf(searchParam) > -1) {
        this.searchFormData.diagnosis_tags[searchParam] = [];
      } else if (searchParam === "subject_staging") {
        this.searchFormData.diagnosis_tags.hystaging_min = "";
        this.searchFormData.diagnosis_tags.hystaging_max = "";
      } else if (searchParam === "subject_disease") {
        this.searchFormData.diagnosis_tags.course_min = "";
        this.searchFormData.diagnosis_tags.course_max = "";
      } else if (searchParam === "mmse") {
        this.searchFormData.diagnosis_tags.mmse_min = "";
        this.searchFormData.diagnosis_tags.mmse_max = "";
      } else if (searchParam === "moca") {
        this.searchFormData.diagnosis_tags.moca_min = "";
        this.searchFormData.diagnosis_tags.moca_max = "";
      } else if (searchParam === "hama") {
        this.searchFormData.diagnosis_tags.hama_min = "";
        this.searchFormData.diagnosis_tags.hama_max = "";
      } else if (searchParam === "hamd") {
        this.searchFormData.diagnosis_tags.hamd_min = "";
        this.searchFormData.diagnosis_tags.hamd_max = "";
      } else if (searchParam === "updrs1") {
        this.searchFormData.diagnosis_tags.updrs1_min = "";
        this.searchFormData.diagnosis_tags.updrs1_max = "";
      } else if (searchParam === "updrs2") {
        this.searchFormData.diagnosis_tags.updrs2_min = "";
        this.searchFormData.diagnosis_tags.updrs2_max = "";
      } else if (searchParam === "updrs3") {
        this.searchFormData.diagnosis_tags.updrs3_min = "";
        this.searchFormData.diagnosis_tags.updrs3_max = "";
      } else if (searchParam === "updrs4") {
        this.searchFormData.diagnosis_tags.updrs4_min = "";
        this.searchFormData.diagnosis_tags.updrs4_max = "";
      }
      this.getDataList();
    },
    //添加到项目
    async handleAddToProject(formData) {
      const me = this;
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$helper.warningMessage(this.$t("notice.select_tip"));
        return;
      }
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });
      let subjects = this.multipleSelection.map(function (item) {
        return item.id;
      });
      let params = {
        subject_ids: subjects,
        request: "addto_project_group",
      };

      params = Object.assign({}, params, formData);
      console.log(params);
      try {
        let res = await projectGroupRequest(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.showAddPopover = false;
          this.projects = [];
          this.$refs.multipleTable.clearSelection();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },

    //添加到项目弹窗
    openToProject() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$helper.warningMessage(this.$t("notice.select_data"));
        return;
      }
      this.showAddPopover = true;
      this.getProjectsOptions();
    },
    //添加到项目弹窗打开时请求项目分组
    async getProjectsOptions() {
      let params = {
        request: "project_list",
        userid: this.$store.state.userid,
      };
      try {
        let res = await projectRequest(params);
        if (res.status === 1 || res.status === 200) {
          this.projects = res.data.length > 0 ? res.data : [];
        }
      } catch (error) {
        this.$helper.errNotify(error.message);
      }
    },

    getGenderKey(gender) {
      return gender === "M" ? "male" : gender === "F" ? "female" : "";
    },
    pollData() {
      this.interval = setInterval(() => {
        this.getProcessList();
      }, 10000);
    },
    clearTimer() {
      clearInterval(this.interval);
      this.interval = null;
    },
    /**请求列表排序 */
    handleSortChange(sort) {
      //console.log(sort);
      if (sort.prop) {
        // 排序: subject_age, study_date, date_update
        this.sort = sort.prop;
        this.orderby = sort.order;
        this.getDataList();
      }
    },

    openTagModelDiagnosis(row) {
      this.edit_subject = row;
      this.selectedTagsDiagnosis = row.diagnosis_tags.diagnosis || "";
      this.showPopoverDiagnosis = true;
    },
    //添加自定义诊断标签
    async addTagDiagnosis(tagName) {
      if (!tagName) {
        this.$helper.warningMessage(this.$t("notice.tag_name_required"));
        return false;
      }

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        name: tagName,
      };
      try {
        let res = await tag_diagnosis_create(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getTagOptionsDiagnosis();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    //保存诊断标签
    async submitTagsDiagnosis(tagname) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        subject_id: this.edit_subject.id,
        diagnosis: tagname, // 字段名： diagnosis
      };
      try {
        let res = await subject_tags(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.showPopoverDiagnosis = false;
          this.edit_subject.diagnosis_tags.diagnosis = tagname;
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        this.$helper.errNotify(error.message);
        loadingInstance.close();
      }
    },

    //诊断form
    openTagModelDisease(row) {
      this.edit_subject = row;
      this.showPopoverDisease = true;
    },
    //保存诊断form
    async submitTagsDisease(tags, subject_id) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        subject_id: subject_id,
        course: tags.course, // 字段名： course
        hy_staging: tags.hy_staging,
        mmse: tags.mmse,
        moca: tags.moca,
        hama: tags.hama,
        hamd: tags.hamd,
        updrs1: tags.updrs1,
        updrs2: tags.updrs2,
        updrs3: tags.updrs3,
        updrs4: tags.updrs4,
        education: tags.education,
      };

      try {
        let res = await subject_tags(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.showPopoverDisease = false;

          this.dataList.forEach((item) => {
            if (item.id === this.rowId) {
              item.diagnosis_tags = tags;
            }
          });
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        this.$helper.errNotify(error.message);
        loadingInstance.close();
      }
    },

    //H-Y分期
    //保存H-Y分期:0，1，1.5，2，2.5，3，4，5
    async submitTagsStaging(tagname) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        subject_id: this.rowId,
        hy_staging: tagname, // 字段名： course
      };

      try {
        let res = await subject_tags(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.showPopoverStaging = false;
          //this.edit_subject.diagnosis_tags.hy_staging = tagname;

          this.dataList.forEach((item) => {
            if (item.id === this.rowId) {
              item.diagnosis_tags.hy_staging = tagname;
            }
          });
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        this.$helper.errNotify(error.message);
        loadingInstance.close();
      }
    },

    //起病侧
    openTagModelSideonset(row) {
      this.edit_subject = row;

      this.selectedTagsSideonset = row.diagnosis_tags.sideonset || "";
      this.showPopoverSideonset = true;
    },

    //添加自定义起病侧标签
    async addTagSideonset(tagName) {
      if (!tagName) {
        this.$helper.warningMessage(this.$t("notice.tag_name_required"));
        return false;
      }

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        name: tagName,
      };
      try {
        let res = await tag_sideonset_create(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getTagOptionsSideonset();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    //保存起病侧 标签内容：左侧、左侧-上肢、左侧-下肢、右侧、右侧-上肢、右侧-下肢、不明确、自定义
    async submitTagsSideonset(tagname) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        subject_id: this.edit_subject.id,
        sideonset: tagname,
      };
      try {
        let res = await subject_tags(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.showPopoverSideonset = false;
          //this.edit_subject.diagnosis_tags.sideonset = tagname;
          this.dataList.forEach((item) => {
            if (item.id === this.edit_subject.id) {
              item.diagnosis_tags.sideonset = tagname;
            }
          });
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        this.$helper.errNotify(error.message);
        loadingInstance.close();
      }
    },
    dataOwnerScope(user) {
      // console.log(user);
      // console.log(this.user);
      return this.user.id === user.user_id || this.user.role == 0;
    },

    //监听键盘esc事件
    handleKeyup(event) {
      if (event.key === "Escape") {
        //console.log("Esc key pressed");
        this.showEditPopover = false;
        this.showOwnerPopover = false;
        this.showTagsPopover = false;
        this.showPopoverDiagnosis = false;
        this.showPopoverDisease = false;
        this.showPopoverStaging = false;
        this.showPopoverSideonset = false;
      }
    },
  },
  computed: {
    showClearAllSearch: function () {
      const _self = this;
      const existSearchParam = [
        "search_number",
        "search_gender",
        "search_age_min",
        "search_age_max",
      ].some(function (item) {
        return !!_self.searchFormData[item];
      });
      const existSearchArr = [
        "search_modality",
        "search_series",
        "search_tag",
      ].some(function (item) {
        return _self.searchFormData[item].length > 0;
      });
      const existDateArr = ["create_date", "study_date"].some(function (item) {
        return _self[item].length > 0;
      });

      const search_diagnosis_tags = !this.areAllValuesEmpty(
        this.searchFormData.diagnosis_tags
      );

      if (
        existSearchParam ||
        existSearchArr ||
        existDateArr ||
        search_diagnosis_tags
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  created() {
    if (
      this.$store.state.dataParams.search_createdate_min != "" &&
      this.$store.state.dataParams.search_createdate_max != ""
    ) {
      this.create_date = [
        this.$store.state.dataParams.search_createdate_min,
        this.$store.state.dataParams.search_createdate_max,
      ];
    }

    if (
      this.$store.state.dataParams.search_studydate_min != "" &&
      this.$store.state.dataParams.search_studydate_max != ""
    ) {
      this.study_date = [
        this.$store.state.dataParams.search_studydate_min,
        this.$store.state.dataParams.search_studydate_max,
      ];
    }
    this.getDataList();
    this.pollData();
  },
  mounted() {
    this.getProcessList();
    this.getCascaderOptions();
    this.getModalityAndSeries();
    this.getTagOptions();

    this.getTagOptionsDiagnosis();
    this.getTagOptionsSideonset();
    this.getTagOptionsHystaging();
    document.body.addEventListener("click", this.hideMenu, false);
    //监听键盘esc事件
    document.addEventListener("keyup", this.handleKeyup);
  },
  beforeDestroy() {
    //监听键盘esc事件
    document.removeEventListener("keyup", this.handleKeyup);
    document.body.removeEventListener("click", this.hideMenu);
    this.clearTimer();
  },
  watch: {
    // noTask(newVal, oldVal) {
    //   console.log(newVal, oldVal);
    //   if (newVal) {
    //     clearInterval(this.interval);
    //     this.interval = null;
    //   }
    // },
    // refresh(newVal, oldVal) {
    //   if (newVal) {
    //     this.getDataList();
    //   }
    // },
    processList(newVal, oldVal) {
      if (newVal.length != oldVal.length) {
        this.getDataList();
      }
    },
  },
  beforeCreate() {
    _that = this;
  },
  filters: {
    formatSearchGender: function (val) {
      return val === "M" ? "男" : val === "F" ? "女" : "";
    },
    formatSearchTag: function (val, tagOptions) {
      var tag = tagOptions.filter(function (item) {
        return item.id == val;
      });
      return tag[0].name || "";
    },
    formatStatus: function (status) {
      switch (status) {
        case "0":
          return _that.$t("package_status.processing");
        case "1":
          return _that.$t("package_status.completed");
        case "2":
          return _that.$t("package_status.failed");
        default:
          return "";
      }
    },
    formatMessage: function (status) {
      switch (status) {
        case "1":
          return _that.$t("package_status.failed_niix");
        case "2":
          return _that.$t("package_status.no_dicom");
        default:
          return _that.$t("package_status.failed");
      }
    },
  },
};
</script>

<style lang="less" scoped>
// .el-table__footer-wrapper,
// .el-table__header-wrapper {
//   overflow: visible;
// }
// .el-table__body-wrapper {
//   overflow-x: auto !important;
// }

/* 设置表格最大高度，使用 calc 计算 */
// .el-table {
//   max-height: calc(100vh - 200px);
// }
.data-manage {
  width: 100%;
  padding-bottom: 60px;
  .data-process {
    margin-bottom: 10px;

    .data-item {
      // margin-bottom: 10px;
      padding: 0 5px 0 10px;
      height: 20px;
      line-height: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      &.item-primary {
        background: #e4eef9;
        color: #027bfe;
      }

      &.item-success {
        background: #e6f1ec;
        color: #26a745;
      }

      &.item-danger {
        background: #f4e8ec;
        color: #dc3545;
      }

      .close-btn {
        width: 20px;
        text-align: center;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }

  .main-content {
    transition: 0.3s ease-in;
  }

  .main-content.active {
    width: calc(~"100% - 240px");
    // transform: translate(-220px);
    // margin-right: 220px;
  }

  .el-checkbox {
    margin-bottom: 0;
    // color: #fff;
  }

  // .el-table .cell {
  //   overflow: visible;
  //   //word-break: keep-all;
  // }

  // .el-table {
  //   overflow: visible;
  // }

  // .el-table__body-wrapper {
  //   overflow: visible !important;
  // }
}

.data-manager-popover {
  .popover-content {
    margin: 120px auto 0;
    width: 700px;
    background: #fff;
  }

  .el-cascader {
    width: 100%;
  }
}

.dialog-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2003;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0, 0.6);

  .dialog-content {
    position: relative;
    margin: 15vh auto;
    border-radius: 3px;
    width: 600px;
    background: #fff;
  }

  .dialog-header {
    padding: 20px 10px;
    border-bottom: 1px solid #dee2e6;
  }

  .dialog-title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
  }

  .dialog-headerbtn {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
  }

  .dialog-body {
    padding: 30px 0;
    text-align: center;
  }
}

.search-drawer {
  padding-bottom: 30px;
  overflow-y: scroll;

  .el-form-item--mini.el-form-item {
    margin-bottom: 10px;
  }

  .el-form-item--mini .el-form-item__label {
    line-height: 20px;
  }

  .el-form--label-top .el-form-item__label {
    padding-bottom: 0;
  }

  .line {
    text-align: center;
  }

  .el-col {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }

  .top-line {
    margin-bottom: 10px;
  }

  .el-select {
    width: 100%;
  }

  .cutting-line {
    margin-bottom: 10px;
    border-top: 1px solid #dddddd;
  }

  .button-wrapper {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #dddddd;
    text-align: center;
  }
}
</style>
